import { Link } from "react-router-dom";

export const MedicineAndHealthcareConst = {
  path: "/single-page/medicine-and-healthcare",
  title: "МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ",
  contentJSX: (
    <>
      <h2>МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн / гибрид</p>
      <p>Язык: русский / английский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. МЕДИЦИНСКАЯ ДИДАКТИКА И ПРЕПОДАВАНИЕ КЛИНИЧЕСКИХ ДИСЦИПЛИН — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>PBL и CBL: клинические сценарии в обучении – 12 ч</li>
        <li>Симуляционные методы и стандартизированные пациенты – 12 ч</li>
        <li>Моделирование и визуализация в медицине – 12 ч</li>
      </ul>
      <h2>II. ОЦЕНИВАНИЕ И АККРЕДИТАЦИЯ В МЕДИЦИНСКОМ ОБРАЗОВАНИИ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>OSCE, MCQ, Mini-CEX: форматы и методики – 12 ч</li>
        <li>Международные стандарты (WFME, AMEE) – 6 ч</li>
        <li>Разработка тестов и оценочных листов – 12 ч</li>
      </ul>
      <h2>III. МЕДИЦИНА И ЦИФРОВЫЕ ТЕХНОЛОГИИ — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Телемедицина и цифровая диагностика – 6 ч</li>
        <li>Использование симуляторов и AR/VR – 6 ч</li>
        <li>Электронные базы данных и клинические рекомендации – 6 ч</li>
        <li>Мобильные медицинские приложения – 6 ч</li>
        <li>Работа с ЭМК и онлайн-платформами – 6 ч</li>
      </ul>
      <h2>IV. ОБРАЗОВАНИЕ ДЛЯ ЗДОРОВЬЯ И ПРОФИЛАКТИКА — 24 ЧАСА</h2>
      <ul className="number">
        <li>Преподавание общественного здравоохранения – 6 ч</li>
        <li>Навыки коммуникации врача и пациента – 6 ч</li>
        <li>Программы профилактики и ЗОЖ – 6 ч</li>
        <li>Социальные и этические аспекты медицины – 6 ч</li>
      </ul>
      <h2>V. ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Разработка курса или тренинга для студентов-медиков – 12 ч</li>
        <li>Презентация и экспертная оценка – 12 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    МЕДИЦИНА И ЗДРАВООХРАНЕНИЕ 
    Общий объём: 144 академических часа
    Формат: онлайн / офлайн / гибрид
    Язык: русский / английский
    Итог: Международный сертификат
    I. МЕДИЦИНСКАЯ ДИДАКТИКА И ПРЕПОДАВАНИЕ КЛИНИЧЕСКИХ ДИСЦИПЛИН — 36 ЧАСОВ
    PBL и CBL: клинические сценарии в обучении – 12 ч
    Симуляционные методы и стандартизированные пациенты – 12 ч
    Моделирование и визуализация в медицине – 12 ч
    II. ОЦЕНИВАНИЕ И АККРЕДИТАЦИЯ В МЕДИЦИНСКОМ ОБРАЗОВАНИИ — 30 ЧАСОВ
    OSCE, MCQ, Mini-CEX: форматы и методики – 12 ч
    Международные стандарты (WFME, AMEE) – 6 ч
    Разработка тестов и оценочных листов – 12 ч
    III. МЕДИЦИНА И ЦИФРОВЫЕ ТЕХНОЛОГИИ — 30 ЧАСОВ
    Телемедицина и цифровая диагностика – 6 ч
    Использование симуляторов и AR/VR – 6 ч
    Электронные базы данных и клинические рекомендации – 6 ч
    Мобильные медицинские приложения – 6 ч
    Работа с ЭМК и онлайн-платформами – 6 ч
    IV. ОБРАЗОВАНИЕ ДЛЯ ЗДОРОВЬЯ И ПРОФИЛАКТИКА — 24 ЧАСА
    Преподавание общественного здравоохранения – 6 ч
    Навыки коммуникации врача и пациента – 6 ч
    Программы профилактики и ЗОЖ – 6 ч
    Социальные и этические аспекты медицины – 6 ч
    V. ИТОГОВЫЙ ПРОЕКТ — 24 ЧАСА
    Разработка курса или тренинга для студентов-медиков – 12 ч
    Презентация и экспертная оценка – 12 ч
  `,
};
